import actions from "./actions";

const initialState = {
  error: null,
  loading: false,
  content: null,
  requesting: false,
};

export default function contentReducer(state = initialState, action) {
  switch (action.type) {
    case actions.ADD_CONTENT_REQUEST:
    case actions.UPDATE_CONTENT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case actions.ADD_CONTENT_SUCCESS:
    case actions.UPDATE_CONTENT_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actions.ADD_CONTENT_ERROR:
    case actions.UPDATE_CONTENT_ERROR:
      return {
        ...state,
        loading: false,
      };
    case actions.GET_CONTENT_REQUEST:
      return {
        ...state,
        requesting: true,
        content: null,
      };
    case actions.GET_CONTENT_SUCCESS:
      return {
        ...state,
        requesting: false,
        content: action.content,
      };
    case actions.GET_CONTENT_ERROR:
      return {
        ...state,
        requesting: false,
        content: null,
      };
    default:
      return state;
  }
}
